import {
  FETCH_PAYMENT_TOKEN_REQUEST,
  FETCH_PAYMENT_TOKEN_SUCCESS,
  FETCH_PAYMENT_TOKEN_FAILURE,
  MAKE_PAYMENT_REQUEST,
  MAKE_PAYMENT_SUCCESS,
  MAKE_PAYMENT_FAILURE,
  FETCH_PAYMENT_HISTORY_REQUEST,
  FETCH_PAYMENT_HISTORY_SUCCESS,
  FETCH_PAYMENT_HISTORY_FAILURE,
  DELETE_CARD_REQUEST,
  DELETE_CARD_FAILURE,
  DELETE_CARD_SUCCESS,
} from "../constants";
import {
  deleteAuthenticationRequest,
  getRequestAuthenticationRequest,
  postAuthenticationRequest,
} from "../../../services/apiManager/apiRequests";
import apiConfig from "../../../services/apiManager/apiConfig";

import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../../utils/snackbarConfig";
import { substituteUrlParams } from "../../../services/apiManager/helper";

export const fetchPaymentToken =
  (id, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: FETCH_PAYMENT_TOKEN_REQUEST,
      });
      const response = await getRequestAuthenticationRequest(
        substituteUrlParams(apiConfig.reservationApis.getPaymentToken, {
          customerId: id,
        }),
        null,
      );
      if (response) {
        dispatch({
          type: FETCH_PAYMENT_TOKEN_SUCCESS,
          payload: response?.response,
        });
        callback(response);
      } else {
        dispatch({
          type: FETCH_PAYMENT_TOKEN_FAILURE,
          payload: {},
        });
        callback({});
        enqueueSnackbar("Error fetching payment details", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
    } catch (error) {
      enqueueSnackbar("Error fetching payment details", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: FETCH_PAYMENT_TOKEN_FAILURE,
      });
    }
  };

export const makePayment =
  (
    {
      customerId,
      reservationId,
      autoPayEnabled = false,
      savePaymentMethod = false,
    },
    values,
    callback = () => {},
    isInvoicePayment = false,
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: MAKE_PAYMENT_REQUEST,
      });
      let response;
      if (isInvoicePayment) {
        response = await postAuthenticationRequest(
          substituteUrlParams(apiConfig.reservationApis.makeInvoicePayment, {
            customerId,
            autoPayEnabled,
            savePaymentMethod,
          }),
          values,
        );
      } else {
        response = await postAuthenticationRequest(
          substituteUrlParams(apiConfig.reservationApis.makePayment, {
            customerId,
            reservationId,
            autoPayEnabled,
            savePaymentMethod,
          }),
          values,
        );
      }
      if (response) {
        dispatch({
          type: MAKE_PAYMENT_SUCCESS,
          payload: response,
        });
        callback(response, "");
      } else {
        dispatch({
          type: MAKE_PAYMENT_FAILURE,
          payload: {},
        });
        callback(false, "");
      }
    } catch (error) {
      let errorMessage = "Try again later";
      if (
        error?.status === 400 &&
        error?.response?.data?.paymentTransactionError
      ) {
        errorMessage = error?.response?.data?.paymentTransactionError;
      }
      errorMessage = error?.response?.data?.message || errorMessage;
      callback(false, errorMessage);
      dispatch({
        type: MAKE_PAYMENT_FAILURE,
      });
    }
  };

export const deleteCard =
  ({ customerId }, values, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: DELETE_CARD_REQUEST,
      });
      let response = await deleteAuthenticationRequest(
        substituteUrlParams(apiConfig.reservationApis.deleteCard, {
          customerId,
        }),
        null,
        values,
      );
      if (response) {
        dispatch({
          type: DELETE_CARD_SUCCESS,
          payload: response,
        });
        callback(response, "");
      } else {
        dispatch({
          type: DELETE_CARD_FAILURE,
          payload: {},
        });
        callback(false, "");
      }
    } catch (error) {
      let errorMessage = "Try again later";
      if (
        error?.status === 400 &&
        error?.response?.data?.paymentTransactionError
      ) {
        errorMessage = error?.response?.data?.paymentTransactionError;
      }
      errorMessage = error?.response?.data?.message || errorMessage;
      callback(false, errorMessage);
      dispatch({
        type: DELETE_CARD_FAILURE,
      });
    }
  };

export const makeACHPayment =
  (customerId, values, callback = () => {}) =>
  async (dispatch) => {
    try {
      let response = await postAuthenticationRequest(
        substituteUrlParams(apiConfig.reservationApis.makeAchPayment, {
          customerId,
        }),
        values,
      );
      if (response) {
        callback(response);
      } else {
        callback(false);
      }
    } catch (error) {
      callback(false);
    }
  };

export const fetchPaymentHistory =
  ({ customerId, reservationId }, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: FETCH_PAYMENT_HISTORY_REQUEST,
      });
      const response = await getRequestAuthenticationRequest(
        apiConfig.reservationApis.paymentHistory,
        {
          q: "*:*",
          "q.op": "OR",
          start: 0,
          rows: 10000,
          wt: "json",
          cl: "OPS",
          fq: `primary_reference_type_code: RESERVATION_ID & fq=payment_status_code: CREATED & fq=reservation_ids: ${reservationId}`,
        },
      );
      if (response?.response?.docs?.length > 0) {
        dispatch({
          type: FETCH_PAYMENT_HISTORY_SUCCESS,
          payload: response?.response?.docs,
        });
        callback(response);
      } else {
        dispatch({
          type: FETCH_PAYMENT_HISTORY_SUCCESS,
          payload: {},
        });
        callback({});
      }
    } catch (error) {
      enqueueSnackbar("Error fetching payment history", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: FETCH_PAYMENT_HISTORY_FAILURE,
      });
    }
  };
